/** @jsx jsx */
import { css, jsx } from '@emotion/react'
import React, { type JSX } from 'react'

export type CardSectionProps = {
  disableElevation?: boolean
  children: React.ReactNode
  id?: string
}

export const CardSection = ({
  children,
  disableElevation,
  ...rest
}: CardSectionProps) => {
  const cardSectionStyle = css`
    background-color: white;
    padding: 30px 20px;
    border-radius: 10px;

    ${disableElevation ? '' : `box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.08);`}
  `

  return (
    <section css={cardSectionStyle} {...rest}>
      {children}
    </section>
  )
}

type HeadingProps = JSX.IntrinsicElements['h1' | 'h2' | 'h3' | 'h4' | 'h5'] & {
  as?: React.ElementType<any>
  disableMarginBottom?: boolean
}
export const Heading = ({
  children,
  as: Component = 'h3',
  disableMarginBottom,
  ...props
}: HeadingProps) => {
  const marginBottom = disableMarginBottom ? '' : '25px'
  const headingStyle = css`
    font-weight: bold;
    font-size: 16px;
    line-height: 125%;
    text-align: center;
    margin-bottom: ${marginBottom};
  `

  return (
    <Component css={headingStyle} {...props}>
      {children}
    </Component>
  )
}

type SectionListProps = {
  children: React.ReactNode
}

export const SectionList = ({ children }: SectionListProps) => {
  return <div css={sectionListStyle}>{children}</div>
}

const sectionListStyle = css`
  display: grid;
  row-gap: 15px;
`
